import React, { useContext } from "react";
import Loadable from "react-loadable";
import Loading from "./global-components/Loading";
import Navbar from "./select-components/navbar-select";
import PageHeader from "./global-components/page-header";
import RegistraionSection from "./section-components/registration";
import EmpresaContext from "../context";
const Footer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "footer" */ "./select-components/footer-select"),
  loading: Loading
});

const Registration = () => {
  const empresa = useContext(EmpresaContext);
  return (
    <div>
      <Navbar />
      <PageHeader
        backgroundImage={
          empresa.info_gen["image-header-pages"] || empresa.banner[0]
        }
        headertitle="Envie seu imóvel"
      />
      <RegistraionSection />
      <Footer />
    </div>
  );
};

export default Registration;
